import { BaseText, Button, theme } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CenterRow, StyledWrapper } from 'styles/ContainerStyles';
import { useUiStore } from 'stores/uiStore';

const NoPaymentRequiredModalContent = () => {
  const { t } = useTranslation();
  return (
    <StyledWrapper>
      <StyledWrapper>
        <BaseText color={theme.colors.gray300} center>
          {t('permit.access.paymentNotRequiredInfo')}
        </BaseText>
      </StyledWrapper>
      <CenterRow>
        <Button
          size="l"
          onPress={() => useUiStore.getState().setSheetModal('')}
          text={t('button.close')}
          testID="close-button"
        />
      </CenterRow>
    </StyledWrapper>
  );
};

export default NoPaymentRequiredModalContent;
